module.exports = __webpack_public_path__ + "static/media/OrangeTV-Live-Button.526f0cbd.png";